<script lang="ts">
  import {onMount, onDestroy} from 'svelte';
  export let onBackdropClick: () => void = () => {};
  let className: string = '';
  export {className as class};

  let portalElement: HTMLDivElement;
  let contentElement: HTMLDivElement;

  // Open content in portal on mount
  // Disable body scrolling while portal is open
  onMount(() => {
    portalElement = document.createElement('div');
    portalElement.className = 'portal';

    if (onBackdropClick) {
      portalElement.addEventListener('click', (e: MouseEvent) => {
        if ((e.target as Node).contains(portalElement)) {
          onBackdropClick();
        }
      });
    }

    portalElement.appendChild(contentElement);
    document.body.appendChild(portalElement);

    document.body.style.overflow = 'hidden';
  });

  // Remove portal and enable body scrolling on unmount
  onDestroy(() => {
    document.body.removeChild(portalElement);

    document.body.style.overflow = '';
  });
</script>

<style lang="postcss">
  :global(.portal) {
    z-index: 40;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
    background: var(--ubilabs-modal-backdrop-background-color);
  }

  :global(.portal > div) {
    padding: 1rem;
    width: 100%;
    min-height: var(--ubilabs-modal-min-height);
    max-height: 100%;
    overflow: auto;
    background: var(--ubilabs-modal-background-color);
    box-shadow: var(--ubilabs-modal-box-shadow);
  }

  @media (min-width: 640px) {
    :global(.portal) {
      padding: 1rem;
    }
  }

  @media (min-width: 768px) {
    :global(.portal) {
      padding: 2.5rem;
    }

    :global(.portal > div) {
      padding: 1.5rem 2rem;
    }
  }
</style>

<div class={className} bind:this={contentElement}>
  <slot />
</div>
